import { format } from 'date-fns'

const formatHour = (hour: number, minute: number): string => {
  const date = new Date(0) // Using a fixed date for time-only formatting
  date.setHours(hour)
  date.setMinutes(minute)
  return format(date, 'h:mmaaa')
}

const generateHoursOptions = (start: number, end: number) => {
  const hoursOptions = []

  for (let i = start; i <= end; i++) {
    const currentHour = i % 24
    const nextHour = (i + 1) % 24

    hoursOptions.push({
      id: `hour${i}00`,
      parentId: 'root',
      displayName: `${formatHour(currentHour, 0)}-${formatHour(
        currentHour,
        30,
      )}`,
    })
    hoursOptions.push({
      id: `hour${i}30`,
      parentId: 'root',
      displayName: `${formatHour(currentHour, 30)}-${formatHour(nextHour, 0)}`,
    })
  }

  return hoursOptions
}

export const locationIntradaySelectOptions = {
  options: {
    revenueCenterMetrics: {
      defaultId: [['all', 'average_net_sales|price']],
      options: [
        // All revenue centers
        { id: 'all', parentId: 'root', displayName: 'All' },
        {
          id: 'average_net_sales|price',
          parentId: 'all',
          displayName: 'Average Sales',
        },
        {
          id: 'average_check_count|number',
          parentId: 'all',
          displayName: 'Average Check Count',
        },
        {
          id: 'average_labor_cost|price',
          parentId: 'all',
          displayName: 'Labor $',
        },
        {
          id: 'average_labor_hour|number',
          parentId: 'all',
          displayName: 'Average Labor Hours',
        },
        {
          id: 'splh|price',
          parentId: 'all',
          displayName: 'SPLH',
        },
        {
          id: 'average_sales_minus_labor_cost|price',
          parentId: 'all',
          displayName: 'Average Sales $ - Labor $',
        },

        // Digital revenue centers
        {
          id: 'digital',
          parentId: 'root',
          displayName: 'Digital',
        },
        {
          id: 'digitalAll',
          parentId: 'digital',
          displayName: 'All Digital',
        },
        {
          id: 'average_digital_sales|price',
          parentId: 'digitalAll',
          displayName: 'Average Sales',
        },
        {
          id: 'average_digital_check_count|number',
          parentId: 'digitalAll',
          displayName: 'Average Check Count',
        },

        {
          id: 'online',
          parentId: 'digital',
          displayName: 'Online',
        },
        {
          id: 'average_revenue_center_sales_online|price',
          parentId: 'online',
          displayName: 'Average Sales',
        },
        {
          id: 'average_revenue_center_check_count_online|number',
          parentId: 'online',
          displayName: 'Average Check Count',
        },

        {
          id: 'dispatch_delivery',
          parentId: 'digital',
          displayName: 'Dispatch / Delivery',
        },
        {
          id: 'average_revenue_center_sales_dispatch_delivery|price',
          parentId: 'dispatch_delivery',
          displayName: 'Average Sales',
        },
        {
          id: 'average_revenue_center_check_count_dispatch_delivery|number',
          parentId: 'dispatch_delivery',
          displayName: 'Average Check Count',
        },

        {
          id: 'third_party',
          parentId: 'digital',
          displayName: '3PD',
        },
        {
          id: 'average_revenue_center_sales_third_party|price',
          parentId: 'third_party',
          displayName: 'Average Sales',
        },
        {
          id: 'average_revenue_center_check_count_third_party|number',
          parentId: 'third_party',
          displayName: 'Average Check Count',
        },

        // Non-digital revenue centers
        {
          id: 'nonDigital',
          parentId: 'root',
          displayName: 'Non-Digital',
        },
        {
          id: 'nonDigitalAll',
          parentId: 'nonDigital',
          displayName: 'All Non-Digital',
        },
        {
          id: 'average_non_digital_sales|price',
          parentId: 'nonDigitalAll',
          displayName: 'Average Sales',
        },
        {
          id: 'average_non_digital_check_count|number',
          parentId: 'nonDigitalAll',
          displayName: 'Average Check Count',
        },

        {
          id: 'dine_in',
          parentId: 'nonDigital',
          displayName: 'Dine In',
        },
        {
          id: 'average_revenue_center_sales_dine_in|price',
          parentId: 'dine_in',
          displayName: 'Average Sales',
        },
        {
          id: 'average_revenue_center_check_count_dine_in|number',
          parentId: 'dine_in',
          displayName: 'Average Check Count',
        },

        {
          id: 'walk_in_to_go',
          parentId: 'nonDigital',
          displayName: 'Walk In - To Go',
        },
        {
          id: 'average_revenue_center_sales_walk_in_to_go|price',
          parentId: 'walk_in_to_go',
          displayName: 'Average Sales',
        },
        {
          id: 'average_revenue_center_check_count_walk_in_to_go|number',
          parentId: 'walk_in_to_go',
          displayName: 'Average Check Count',
        },

        {
          id: 'call_in_to_go_call_center',
          parentId: 'nonDigital',
          displayName: 'Call In - To Go / Call Center',
        },
        {
          id: 'average_revenue_center_sales_call_in_to_go_call_center|price',
          parentId: 'call_in_to_go_call_center',
          displayName: 'Average Sales',
        },
        {
          id: 'average_revenue_center_check_count_call_in_to_go_call_center|number',
          parentId: 'call_in_to_go_call_center',
          displayName: 'Average Check Count',
        },
      ],
    },
    dayOfWeek: {
      defaultId: [['dow5'], ['dow6']],
      options: [
        { id: 'dow7', parentId: 'root', displayName: 'Sunday' },
        { id: 'dow1', parentId: 'root', displayName: 'Monday' },
        { id: 'dow2', parentId: 'root', displayName: 'Tuesday' },
        { id: 'dow3', parentId: 'root', displayName: 'Wednesday' },
        { id: 'dow4', parentId: 'root', displayName: 'Thursday' },
        { id: 'dow5', parentId: 'root', displayName: 'Friday' },
        { id: 'dow6', parentId: 'root', displayName: 'Saturday' },
      ],
    },
    hours: {
      defaultId: [['hour2300'], ['hour2330'], ['hour2400'], ['hour2430']],
      options: generateHoursOptions(5, 25),
    },
  },
}

export function getRevenueCenterMetricDisplayName(metricId: string) {
  const allRevenueCenterOptions =
    locationIntradaySelectOptions.options.revenueCenterMetrics.options
  const selectedOption = allRevenueCenterOptions.find(
    (option) => option.id === metricId,
  )
  return selectedOption?.displayName || ''
}
